import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import {
  useServiceRequestFormFlow,
  UseServiceRequestFormFlowReturn,
} from './CustomHooks/useServiceRequestFormFlow';
import {
  useServiceRequestReferenceData,
  UseServiceRequestReferenceDataReturn,
} from './CustomHooks/useServiceRequestReferenceData';
import {
  ServiceRequestFormContext,
  ServiceRequestFormContextValue,
} from './CustomHooks/ServiceRequestFormContext';
import ServiceRequestFormSteps from './ServiceRequestFormSteps';
import './ServiceRequestForm.scss';

interface ServiceRequestFormProps {
  serviceRequest?: any;
  from?: string;
  onClose?: () => void;
  onExit?: () => void;
  propertyData?: any;
  propertyDisabled?: boolean;
  updateServiceRequestFormVisibleStatus?: (newStatus: boolean) => void;
  propertyId?: any;
  serviceRequestSuiteInfo?: any;
  [key: string]: any;
}

const ServiceRequestForm = ({
  serviceRequest,
  from,
  onClose,
  onExit,
  propertyData,
  propertyDisabled,
}: ServiceRequestFormProps) => {
  const user: any = useSelector(selectAuthenticatedUser);

  const flow: UseServiceRequestFormFlowReturn = useServiceRequestFormFlow(
    serviceRequest ?? undefined
  );

  const reference: UseServiceRequestReferenceDataReturn =
    useServiceRequestReferenceData(user);

  const handleExit = (): void => {
    if (onExit) {
      onExit();
    }

    if (onClose) {
      onClose();
    }
  };

  const contextValue: ServiceRequestFormContextValue = {
    ...flow,
    reference,
    user,
    from,
    propertyData,
    propertyDisabled,
    onClose,
    onExit: handleExit,
  };

  return (
    <ServiceRequestFormContext.Provider value={contextValue}>
      <ServiceRequestFormSteps />
    </ServiceRequestFormContext.Provider>
  );
};

export default ServiceRequestForm;